import React from "react";
import { Form } from "react-final-form";
import { FORM_ERROR } from "final-form";
import createDecorator from "final-form-focus";
import { injectIntl, FormattedMessage } from "react-intl";
import { compose } from "redux";
import { connect } from "react-redux";
import { string as yupString } from "yup";
import { Button } from "@ebsco-ui/ebsco-ui";
import FormErrorNotification from "../../form-error-notification";
import sharedMessages from "../../../../shared-messages";
import {
  requestVerificationDataRequest,
  requestVerificationDataSuccess,
  requestVerificationDataFailure,
  getUsernamePrefill
} from "../../../store/password/reset";
import { TextInputField } from "../../shared/fields";
import { useEdgeApiContext } from "../../edge-api";
import messages from "./request-verification-data-form-messages";

import "./request-verification-data-form.scss";

const focusOnErrors = createDecorator();

const RequestVerificationDataForm = ({
  intl: { formatMessage },
  reqVerificationDataRequest,
  reqVerificationDataSuccess,
  reqVerificationDataFailure,
  usernamePrefill
}) => {
  const personalUserApi = useEdgeApiContext();

  const primaryEmailValidationSchema = yupString().required(
    formatMessage(messages.requireUsername)
  );

  const onSubmit = async data => {
    try {
      const { username } = data;
      reqVerificationDataRequest();

      const {
        data: responseData
      } = await personalUserApi.postPersonalUserVerify(username);
      reqVerificationDataSuccess({ username, ...responseData });
    } catch (error) {
      reqVerificationDataFailure(error);
      let formErrors = {
        [FORM_ERROR]: {
          headerMessage: formatMessage(sharedMessages.somethingWentWrong),
          descriptionMessage: formatMessage(messages.unableToSubmitRequest)
        }
      };

      if (error.response?.status === 429) {
        formErrors = {
          [FORM_ERROR]: {
            headerMessage: formatMessage(sharedMessages.somethingWentWrong),
            descriptionMessage: formatMessage(
              sharedMessages.exceededAllowedRequestAttempts
            )
          }
        };
      }
      return formErrors;
    }
  };

  return (
    <div className="request-verification-data-form">
      <Form
        onSubmit={onSubmit}
        initialValues={{ username: usernamePrefill }}
        decorators={[focusOnErrors]}
      >
        {({
          handleSubmit,
          submitting,
          submitFailed,
          submitError,
          modifiedSinceLastSubmit,
          initialValues,
          dirty
        }) => {
          const disableSave =
            submitting ||
            (submitFailed && !modifiedSinceLastSubmit) ||
            (!dirty && !initialValues.username);

          return (
            <form onSubmit={handleSubmit}>
              {submitError && <FormErrorNotification {...submitError} />}
              <h2 className="reset-instructions">
                {formatMessage(messages.resetPasswordInstructions)}
              </h2>
              <TextInputField
                id="username"
                className="username"
                name="username"
                autoCapitalize="off"
                label={formatMessage(messages.username)}
                validationSchema={primaryEmailValidationSchema}
                aria-required="true"
              />
              <Button
                className="reset-button"
                type="submit"
                disabled={disableSave}
                styleType="solid"
              >
                <FormattedMessage {...messages.reset} />
              </Button>
            </form>
          );
        }}
      </Form>
    </div>
  );
};

const mapDispatchToProps = {
  reqVerificationDataRequest: requestVerificationDataRequest,
  reqVerificationDataSuccess: requestVerificationDataSuccess,
  reqVerificationDataFailure: requestVerificationDataFailure
};

const mapStateToProps = state => ({
  usernamePrefill: getUsernamePrefill(state)
});

export { RequestVerificationDataForm };
export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(RequestVerificationDataForm);
